import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "How long does a typical project take?",
      answer:
        "It depends on scope. A simple website or MVP can take 2–4 weeks, while a full app or complex platform may take 2–3 months. After our first discussion, we give you a clear timeline before starting.",
    },
    {
      question: "How much will my project cost?",
      answer:
        "Every project is different, so we price based on your specific needs and scope. We offer flexible engagement models—fixed-price for defined projects and dedicated-team options for ongoing work. Share your idea and we'll give you a transparent estimate.",
    },
    {
      question: "Do you work with startups and small businesses?",
      answer:
        "Absolutely. We're startup-friendly and love working with founders and small teams. We can start small with an MVP and scale up as your business grows.",
    },
    {
      question: "Will my idea and data stay confidential?",
      answer:
        "Yes. We're happy to sign an NDA before discussing your project in detail. We treat your idea, data, and business information as private and handle it with care.",
    },
    {
      question: "What happens after the product launches?",
      answer:
        "We don't disappear after launch. We offer ongoing maintenance and support plans to keep everything running smoothly. Need new features or major updates later? We're happy to take those on as a separate scope—just reach out and we'll plan it together.",
    },
    {
      question: "How do we communicate during the project?",
      answer:
        "We believe in full transparency. You'll get regular updates, working demos at each stage, and a direct line to our team via your preferred channel—email, WhatsApp, or calls.",
    },
  ];

  return (
    <section className="faq" id="faq">
      <h2>Frequently Asked Questions</h2>
      <p className="section-subtitle">
        Quick answers to the things most clients ask before getting started
      </p>

      <div className="faq-list">
        {faqs.map((faq, i) => (
          <motion.div
            key={i}
            className={`faq-item ${openIndex === i ? "open" : ""}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.05 }}
          >
            <button
              className="faq-question"
              onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
            >
              <span>{faq.question}</span>
              <span className="faq-toggle">{openIndex === i ? "−" : "+"}</span>
            </button>
            <AnimatePresence>
              {openIndex === i && (
                <motion.div
                  className="faq-answer"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <p>{faq.answer}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
